const validarCNPJ = (paramCnpj) => {
  // if (paramCnpj) {
  //   const cnpj = paramCnpj.replace(/[^\d]+/g, '');
  //   if (cnpj.length !== 14) {
  //     return false;
  //   }
  //   if (/^(\d)\1+$/.test(cnpj)) {
  //     return false;
  //   }
  //   const t = cnpj.length - 2;
  //   const d = cnpj.substring(t);
  //   // eslint-disable-next-line
  //   const d1 = parseInt(d.charAt(0));
  //   // eslint-disable-next-line
  //   const d2 = parseInt(d.charAt(1));
  //   const calc = (x) => {
  //     const n = cnpj.substring(0, x);
  //     let y = x - 7;
  //     let s = 0;
  //     let r = 0;
  //     // eslint-disable-next-line
  //     for (let i = x; i >= 1; i--) {
  //       // eslint-disable-next-line
  //       s += n.charAt(x - i) * y--;
  //       if (y < 2) {
  //         y = 9;
  //       }
  //     }
  //     // eslint-disable-next-line
  //     r = 11 - s % 11;
  //     return r > 9 ? 0 : r;
  //   };
  //   return calc(t) === d1 && calc(t + 1) === d2;
  // }
  // return true;
  if (paramCnpj) {
    const cnpj = paramCnpj.replace(/[^a-zA-Z0-9]/g, '').toUpperCase();

    if (cnpj.length !== 14) return false;
    if (cnpj === '00000000000000') return false;
    if (!/^([A-Z\d]){12}(\d){2}$/.test(cnpj)) return false;

    const valorBase = '0'.charCodeAt(0);
    const pesosDV = [6, 5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];

    let somatorioDV1 = 0;
    let somatorioDV2 = 0;

    for (let i = 0; i < 12; i += 1) {
      const asciiDigito = cnpj.charCodeAt(i) - valorBase;
      somatorioDV1 += asciiDigito * pesosDV[i + 1];
      somatorioDV2 += asciiDigito * pesosDV[i];
    }

    const dv1 = somatorioDV1 % 11 < 2 ? 0 : 11 - (somatorioDV1 % 11);
    somatorioDV2 += dv1 * pesosDV[12];
    const dv2 = somatorioDV2 % 11 < 2 ? 0 : 11 - (somatorioDV2 % 11);

    return cnpj.substring(12) === `${dv1}${dv2}`;
  }
  return true;
};

export default validarCNPJ;



// WEBPACK FOOTER //
// ./src/utils/validator/cnpjValidator.js